export const exchangeRateCurrencies = [
    {
        currency_code: 938,
        currency_symbol: 'SDG',
    },
    {
        currency_code: 784,
        currency_symbol: 'AED',
    },
    {
        currency_code: 840,
        currency_symbol: 'USD',
    },
    // {
    //   currency_code: 949,
    //   currency_symbol: 'TRY'
    // },
    // {
    //   currency_code: 124,
    //   currency_symbol: 'CAD'
    // },
    {
        currency_code: 818,
        currency_symbol: 'EGP',
    },
    {
        currency_code: 682,
        currency_symbol: 'SAR',
    },
    // {
    //   currency_code: 512,
    //   currency_symbol: 'OMR'
    // },
    // {
    //   currency_code: 414,
    //   currency_symbol: 'KWD'
    // },
    {
        currency_code: 978,
        currency_symbol: 'EUR',
    },
    {
        currency_code: 826,
        currency_symbol: 'GBP',
    },
    // {
    //   currency_code: 634,
    //   currency_symbol: 'QAR'
    // },
    // {
    //   currency_code: 48,
    //   currency_symbol: 'BHD'
    // },
];
